// extracted by mini-css-extract-plugin
export default {"root":"page-layout_root_v_RaE","content":"page-layout_content_s6sC6"};